import React from 'react';
import { Box, Divider, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import AssessmentStatusDetails from './AssessmentStatusDetails';

type Props = {
  showHeader?: boolean;
  showDivider?: boolean;
  allModuleHeaderList: any[];
  title: string;
};

const BaseAssessmentHeader: React.FC<Props> = ({
  showHeader = true,
  showDivider = true,
  allModuleHeaderList,
  title
}) => {
  const { t } = useTranslation(['Reports']);
  const classes = useStyles();

  return (
    <>
      <AssessmentStatusDetails headerList={allModuleHeaderList} title={title} />
      {showDivider && <Divider style={{ marginTop: '24px', marginBottom: '32px' }} />}
      <Box className={classes.container}>
        {showHeader && (
          <>
            <Typography className={classes.headers} style={{ marginRight: 10 }}>
              {t('MODULE 1')}
            </Typography>
            <Typography className={classes.headers} style={{ marginRight: 10 }}>
              {t('MODULE 2')}
            </Typography>
            <Typography className={classes.headers}>{t('MODULE 3')}</Typography>
          </>
        )}
      </Box>
    </>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flex: 0.85,
    padding: 1,
    justifyContent: 'flex-end'
  },
  headers: {
    fontSize: 12,
    backgroundColor: '#EAEAEA',
    flex: 0.29,
    textAlign: 'center',
    lineHeight: 'unset',
    fontWeight: 600
  }
}));

export default BaseAssessmentHeader;
